import { Checkbox } from "@nextui-org/react";
const recallcategoriescolumn = [
  {
    key: "num",
    label: "SN.",
  },
  {
    key: "name",
    label: "Name",
  },
  {
    key: "recall",
    label: "Recall",
  },
  {
    key: "isLive",
    label: "Status",
  },
  {
    key: "actions",
    label: "Actions",
  },
];

export { recallcategoriescolumn };
